module.exports = __webpack_public_path__ + "img/a1.e6bb9d14.jpg";